export const MIN_VENDOR_NAME_LENGTH = 3;
export const MAX_VENDOR_NAME_LENGTH = 150;
export const MAX_VENDOR_DESCRIPTION_LENGTH = 300;

const NAME_CHAR_CLASS = "A-Za-z0-9\\s.&/+'`*-";

export const ALLOWED_VENDOR_NAME_REGEX = new RegExp(`^[${NAME_CHAR_CLASS}]+$`);
export const INVALID_VENDOR_NAME_REGEX = new RegExp(`[^${NAME_CHAR_CLASS}]`, 'g');

export const sanitizeVendorName = (value: string): string => value.replace(INVALID_VENDOR_NAME_REGEX, '');

export const normalizeVendorName = (value: string): string => value.trim().toLowerCase();
